import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { EnrollmentComponent, EnrollSponseeComponent, EnrollSponsorComponent, ReviewComponent } from './index';
import { SharedModule } from '../../shared/shared.module';
import { ReleaseSponsorshipComponent } from './release-sponsorship/release-sponsorship.component';
import { ExpiredSponsorshipComponent } from './expired-sponsorship/expired-sponsorship.component';
import { SubstitutionService } from '../shared/service/substitution.service';
import { ExpressCleanupComponent } from './express-cleanup/express-cleanup.component';
import { RenewalReminderComponent } from './renewal-reminder/renewal-reminder.component';
import { CommunicationService } from '../shared/service/communication.service';
import { TooltipComponent } from './tooltip.component';
import { PhonePipe } from '../../shared/phonepipe';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [
    EnrollmentComponent,
    EnrollSponseeComponent,
    EnrollSponsorComponent,
    ReviewComponent,
    ReleaseSponsorshipComponent,
    ExpiredSponsorshipComponent,
    ExpressCleanupComponent,
    RenewalReminderComponent,
   
  ],
  providers: [SubstitutionService, DatePipe, CommunicationService, PhonePipe]
})
export class EnrollmentModule { }
